import React, { useState } from "react";
import { Container, Form, Row, Col } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "./UnifiedFormStyles.css";
import AppButton from "../../Components/MerchantButton";
import { useNavigate } from "react-router-dom";
import { submitForm } from "../../Helpers/API/formsAPI";
import { getRegionConfig } from "./config/regionConfig";
import { compressAndUpload } from "../../Helpers/Utils/photoUpload";
import { Modal, Button } from "react-bootstrap"; 
function CompetitorPriority({ navigation, primaryDetails, setPrimaryDetails }) {
  const [isError, setIsError] = useState({});
  const [isUploading, setIsUploading] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const handlePhotoUpload = async (e, fieldName) => {
    const file = e.target.files[0];
    if (!file) return;

    if (file.size > 5 * 1024 * 1024) {
      toast.error("Photo exceeds 5MB limit. Please retake the photo.", {
        autoClose: 3000, hideProgressBar: true, theme: "colored"
      });
      e.target.value = '';
      return;
    }

    setIsUploading(true);
    try {
      const uploadResult = await compressAndUpload(file);
      if (!uploadResult.success) {
        toast.error(uploadResult.error || "Upload failed. Please try again.");
        e.target.value = '';
        return;
      }
      setPrimaryDetails(prev => ({
        ...prev,
        [`${fieldName}_temp_path`]: uploadResult.temp_path
      }));
      if (isError[fieldName]) {
        setIsError(prev => ({ ...prev, [fieldName]: false }));
      }
    } catch (error) {
      toast.error("Error uploading photo");
    } finally {
      setIsUploading(false);
    }
  };
  const reasonOptions = ["Yes", "No"];
  const navigate = useNavigate();
  
  // Check if we should show the full competitor form or just the photo upload
  const showFullForm = primaryDetails.not_joined_maya_program_reason === "Competitor's  Priority";

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setPrimaryDetails((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (isError[name]) {
      setIsError((prev) => ({
        ...prev,
        [name]: false,
      }));
    }
  };

  const validateForm = () => {
    const errors = {};

    // Always validate store front photo as it's always required
    if (!primaryDetails.store_front_photo_temp_path) {
      errors.store_front_photo = true;
    }

    // Only validate these fields if showFullForm is true
    if (showFullForm) {
      if (!primaryDetails.which_acquirer) {
        errors.which_acquirer = true;
      }
      if (!primaryDetails.on_going_promo) {
        errors.on_going_promo = true;
      }

      // Only validate promo fields if on_going_promo is 'Yes'
      if (primaryDetails.on_going_promo === 'Yes') {
        if (!primaryDetails.promo_title) {
          errors.promo_title = true;
        }
        if (!primaryDetails.promo_mechanics) {
          errors.promo_mechanics = true;
        }
        if (!primaryDetails.duration) {
          errors.duration = true;
        }
        // promo_merch_mats is optional as per the form
      }
    }

    setIsError(errors);
    return Object.keys(errors).length === 0;
  };

  const isFormValid = () => {
    // Always check for store front photo
    if (!primaryDetails.store_front_photo_temp_path) {
      return false;
    }

    // If full form is shown, check additional fields
    if (showFullForm) {
      if (!primaryDetails.which_acquirer || !primaryDetails.on_going_promo) {
        return false;
      }

      // If on_going_promo is 'Yes', check promo fields
      if (primaryDetails.on_going_promo === 'Yes') {
        if (!primaryDetails.promo_title || !primaryDetails.promo_mechanics || !primaryDetails.duration) {
          return false;
        }
      }
    }

    return true;
  };
    const handleBack = () => {
    navigation.previous();
  };

  const handleNext = () => {
    if (!validateForm()) {
      toast.error("Please fill in all required fields.");
      return;
    }
    setShowConfirmModal(true); // ✅ show modal instead of direct submit
  };

    const handleConfirmSubmit = async () => {
      setIsSubmitting(true);
      try {
        const regionConfig = getRegionConfig(primaryDetails?.region);
        const res = await submitForm(primaryDetails, regionConfig);
  
        if (res?.data) {
          try {
            localStorage.removeItem('maya-form-data');
            localStorage.removeItem('maya-form-details');
            localStorage.removeItem('maya-form-current-step');
            localStorage.removeItem('maya-form-history');
            localStorage.setItem('form_completed', 'true');
          } catch (e) {}
          setShowConfirmModal(false);
          navigate('/timein', { replace: true });
        } else {
          toast.error("Submit failed. Please try again.", { autoClose: 2500, hideProgressBar: true, theme: "colored" });
        }
      } catch (err) {
        toast.error("Something went wrong while submitting.", { autoClose: 2500, hideProgressBar: true, theme: "colored" });
      } finally {
        setIsSubmitting(false);
      }
    };

  const handleCancelSubmit = () => {
    setShowConfirmModal(false);
  };
  return (
    <div className="form-bg">
      <Container>
        <ToastContainer />
        <Row className="justify-content-md-center">
          <Col md={10}>
            <div className="form-main-header">
              <h4 className="form-title">STORE FRONT & COUNTER PHOTO</h4>
            </div>
            <div className="form-main">
              <div className="form-main-content">
                <Form>
                  {showFullForm ? (
                    <>
                      <Form.Group className="mb-5" controlId="which_acquirer">
                        <Form.Label className="form-label">
                          Which Acquirer <span className="form-required">*</span>
                        </Form.Label>

                        <Form.Select
                          name="which_acquirer"
                          value={primaryDetails.which_acquirer || ""}
                          onChange={handleInputChange}
                          className={`form-input ${isError.which_acquirer ? "form-input-error" : ""}`}
                        >
                          <option value="">-- Select an option --</option>
                          <option value="GCash">GCash</option>
                          <option value="BDO">BDO</option>
                          <option value="BPI">BPI</option>
                          <option value="Metro Bank">Metro Bank</option>
                          <option value="AUB">AUB</option>
                          <option value="Other">Other</option>
                        </Form.Select>

                        {isError.which_acquirer && (
                          <div className="form-error">
                            Please select an acquirer.
                          </div>
                        )}
                      </Form.Group>

                      <Form.Group className="mb-4" controlId="on_going_promo">
                        <Form.Label className="form-label">
                          On-going Promo<span className="form-required">*</span>
                        </Form.Label>
                        <div className="form-radio-group">
                          {reasonOptions.map((reason) => (
                            <div
                              key={reason}
                              className={`form-radio-item ${
                                primaryDetails.on_going_promo === reason
                                  ? "selected"
                                  : ""
                              }`}
                            >
                              <Form.Check
                                type="radio"
                                name="on_going_promo"
                                value={reason}
                                label={reason}
                                onChange={handleInputChange}
                                checked={primaryDetails.on_going_promo === reason}
                                className="form-radio"
                              />
                            </div>
                          ))}
                        </div>
                        {isError.not_joined_maya_program_reason && (
                          <div className="form-error">
                            Please select a reason for not joining Maya Mall Program.
                          </div>
                        )}
                      </Form.Group>
                      {primaryDetails.on_going_promo === "Yes" && (
                        <>
                          <Form.Group className="mb-4" controlId="promo_title">
                            <Form.Label className="form-label">
                              Promo Title<span className="form-required">*</span>
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name="promo_title"
                              value={primaryDetails.promo_title || ""}
                              onChange={handleInputChange}
                              placeholder="Enter reason"
                              className={`form-input ${isError.promo_title ? "form-input-error" : ""}`}
                            />
                            {isError.promo_title && (
                              <div className="form-error">Reason is required.</div>
                            )}
                          </Form.Group>

                          <Form.Group className="mb-4" controlId="promo_mechanics">
                            <Form.Label className="form-label">
                              Promo Mechanics{' '}
                              <span className="form-required">*</span>
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name="promo_mechanics"
                              value={primaryDetails.promo_mechanics || ""}
                              onChange={handleInputChange}
                              placeholder="Enter reason"
                              className={`form-input ${isError.promo_mechanics ? "form-input-error" : ""}`}
                            />
                            {isError.promo_mechanics && (
                              <div className="form-error">Reason is required.</div>
                            )}
                          </Form.Group>

                          <Form.Group className="mb-4" controlId="duration">
                            <Form.Label className="form-label">
                              Duration<span className="form-required">*</span>
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name="duration"
                              value={primaryDetails.duration || ""}
                              onChange={handleInputChange}
                              placeholder="Enter reason"
                              className={`form-input ${isError.duration ? "form-input-error" : ""}`}
                            />
                            {isError.duration && (
                              <div className="form-error">Reason is required.</div>
                            )}
                          </Form.Group>

                          <Form.Group className="mb-4">
                            <Form.Label className="form-label">
                              Promo Merch Mats and/or Memo
                              {primaryDetails.promo_merch_mats_temp_path && !isUploading && (
                                <span style={{ marginLeft: '10px', color: '#28a745' }}>✅ Uploaded</span>
                              )}
                            </Form.Label>
                            <Form.Text className="form-hint">
                              Upload a photo of Promo Merch Mats and/or Memo
                            </Form.Text>
                            <Form.Control
                              type="file"
                              accept="image/*"
                              onChange={(e) => handlePhotoUpload(e, 'promo_merch_mats')}
                              isInvalid={isError.promo_merch_mats}
                              disabled={isUploading}
                            />
                            {isUploading && <div style={{ color: '#007bff', fontSize: '13px', marginTop: '6px' }}>⏳ Uploading...</div>}
                            {isError.promo_merch_mats && (
                              <div className="form-error">Required</div>
                            )}
                          </Form.Group>
                        </>
                      )}
                    </>
                  ) : (
                    <div className="mb-4">
                      <p className="text-muted">Please provide a photo of the store front and counter.</p>
                    </div>
                  )}
                  <Form.Group className="mb-4">
                    <Form.Label className="form-label">
                      Store front and counter photo with Marking{" "}
                      <span className="form-required">*</span>
                      {primaryDetails.store_front_photo_temp_path && !isUploading && (
                        <span style={{ marginLeft: '10px', color: '#28a745' }}>✅ Uploaded</span>
                      )}
                    </Form.Label>
                    <Form.Text className="form-hint">
                      Upload photo of store front and counter photo with Marking
                    </Form.Text>
                    <Form.Control
                      type="file"
                      accept="image/*"
                      onChange={(e) => handlePhotoUpload(e, 'store_front_photo')}
                      isInvalid={isError.store_front_photo}
                      disabled={isUploading}
                    />
                    {isUploading && <div style={{ color: '#007bff', fontSize: '13px', marginTop: '6px' }}>⏳ Uploading...</div>}
                    {isError.store_front_photo && (
                      <div className="form-error">Required</div>
                    )}
                  </Form.Group>

                  <div className="form-btn-row">
                    <AppButton
                      onClick={handleBack}
                      variant="back"
                      className="form-btn variant-secondary"
                    >
                      ← Back
                    </AppButton>
                    <AppButton
                      onClick={handleNext}
                      variant="next"
                      className="form-btn variant-primary"
                      disabled={!isFormValid()}
                    >
                      Submit
                    </AppButton>
                  </div>
                </Form>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
      <Modal show={showConfirmModal} onHide={handleCancelSubmit} centered>
        <Modal.Header closeButton className="border-0 pb-0">
          <Modal.Title className="w-100 text-center fw-bold text-primary">
            ⚠️ Confirm Submission
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center py-4">
          <h5 className="mb-3 text-dark">Are you sure you want to proceed?</h5>
          <p className="text-muted mb-0">
            <strong>Once submitted, you can't go back to make changes.</strong>
          </p>
        </Modal.Body>
        <Modal.Footer className="border-0 justify-content-center pt-0">
          <Button
            variant="outline-secondary"
            onClick={handleCancelSubmit}
            className="px-4 me-3"
            style={{ minWidth: '100px' }}
            disabled={isSubmitting}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleConfirmSubmit}
            className="px-4"
            style={{ minWidth: '100px', backgroundColor: '#007bff' }}
            disabled={isSubmitting}
          >
            {isSubmitting ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                Submitting...
              </>
            ) : (
              'Yes, Proceed'
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default CompetitorPriority;
